











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgFeatures_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgAdmin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useAI",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "4b5931cef65bc443d85dcdf6c9271b32";

export default node;
